const getBusinessFax = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business && business['Company Contact'] && business['Company Contact'].ID) {
    return business['Company Contact'].Fax;
  }
  return null;
};

export default getBusinessFax;



// WEBPACK FOOTER //
// ./src/utils/print/getBusinessFax.js